/**
 *
 * Employees14366
 *
 */

export const ALPHA_COM_ASSIGNED = '4051732437000';
export const UK_TSVETNOY_ASSIGNED = '4547325849000';
export const UK_TSVETNOY_CLEANING_ASSIGNED = '3959751382000';
export const MELIORA_PLACE_ASSIGNED = '4544085413000';
